/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_StyleInputs */

const en_field_style = /** @type {(inputs: Field_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style`)
};

const es_field_style = /** @type {(inputs: Field_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo`)
};

const fr_field_style = /** @type {(inputs: Field_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style`)
};

const de_field_style = /** @type {(inputs: Field_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stil`)
};

const ja_field_style = /** @type {(inputs: Field_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイル`)
};

const zh_field_style = /** @type {(inputs: Field_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`风格`)
};

const ar_field_style = /** @type {(inputs: Field_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النمط`)
};

const id_field_style = /** @type {(inputs: Field_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gaya`)
};

const it_field_style = /** @type {(inputs: Field_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stile`)
};

const ru_field_style = /** @type {(inputs: Field_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стиль`)
};

const pt_field_style = /** @type {(inputs: Field_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo`)
};

const ko_field_style = /** @type {(inputs: Field_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스타일`)
};

/**
* | output |
* | --- |
* | "Style" |
*
* @param {Field_StyleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_style = /** @type {((inputs?: Field_StyleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_StyleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_style(inputs)
	if (locale === "es") return es_field_style(inputs)
	if (locale === "fr") return fr_field_style(inputs)
	if (locale === "de") return de_field_style(inputs)
	if (locale === "ja") return ja_field_style(inputs)
	if (locale === "zh") return zh_field_style(inputs)
	if (locale === "ar") return ar_field_style(inputs)
	if (locale === "id") return id_field_style(inputs)
	if (locale === "it") return it_field_style(inputs)
	if (locale === "ru") return ru_field_style(inputs)
	if (locale === "pt") return pt_field_style(inputs)
	return ko_field_style(inputs)
});